import React, { useEffect, useState } from "react";
import { db, auth } from "../../services/firebase";
import { useParams, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { doc, getDoc } from 'firebase/firestore';
import { ReactComponent as DemostracionesIcon } from '../../assets/icons/MenuIcon.svg'; // Asumiendo que existe un icono específico
import LoadingSpinner from '../LoadingSpinner'

const DemostracionesDetails = () => {
const { id } = useParams();
const navigate = useNavigate();
const [demostracion, setDemostracion] = useState(null);
const [isLoading, setIsLoading] = useState(true);
const [error, setError] = useState(null);
const [postMortemText, setPostMortemText] = useState('');
const [isFinished, setIsFinished] = useState(false);
// Se eliminan estados específicos de Eventos (botellasUsadas, agasajados)

const fetchDemostracion = async () => {
if (!id) {
setIsLoading(false);
return;
}
setIsLoading(true);
try {
// 1. CAMBIO CLAVE: Colección 'demostraciones'
const docRef = doc(db, 'demostraciones', id);
const docSnap = await getDoc(docRef);

if (docSnap.exists()) {
const demoData = docSnap.data();
// 2. CAMBIO CLAVE: Cambiar 'evento' por 'demostracion'
setDemostracion({ id: docSnap.id, ...demoData });
setPostMortemText(demoData.post_mortem || '');
setIsFinished(demoData.finished || false);
// Se elimina la inicialización de botellasUsadas y agasajados
} else {
setError('No se encontró la demostración.');
}
} catch (err) {
console.error('Error al obtener la demostración:', err);
setError('Error al cargar la información de la demostración.');
} finally {
setIsLoading(false);
}
};

useEffect(() => {
fetchDemostracion();
}, [id]);

const handleSavePostMortem = async () => {
try {
const user = auth.currentUser;
if (!user) {
alert('Debes estar logueado para guardar los cambios.');
return;
}
const idToken = await user.getIdToken();

const updateData = {
post_mortem: postMortemText,
finished: true,
// Se eliminan botellasUsadas y agasajados
};

// 3. CAMBIO CLAVE: Ruta del backend para demostraciones
// Asumiendo una estructura similar: /post-mortem/demostracion/[id]
const response = await fetch(`https://backend-288175208699.europe-west1.run.app/post-mortem/demostracion/${id}`, {
method: 'PUT',
headers: {
'Content-Type': 'application/json',
'Authorization': `Bearer ${idToken}`,
},
body: JSON.stringify(updateData),
});

const data = await response.json();

if (response.ok) {
alert(data.mensaje);
fetchDemostracion();
} else {
alert(`Error: ${data.error}`);
}

} catch (err) {
console.error('Error al guardar el post-mortem:', err);
alert('Ocurrió un error al conectar con el servidor.');
}
};


const formatearPrecio = (precio) => {
const parsedPrecio = parseFloat(precio);
if (isNaN(parsedPrecio)) return 'No disponible';
return parsedPrecio.toLocaleString('es-AR');
};

if (isLoading) {
return <LoadingSpinner />;
}

if (error) {
return <div className="event-details-error">{error}</div>;
}

if (!demostracion) {
return <div className="event-details-not-found">No se encontró la demostración.</div>;
}

// 4. CAMBIO CLAVE: Usar 'cantidadPlazas' como 'invitados'
const staff = demostracion.staff || [];
const cantidadInvitados = demostracion.cantidadPlazas || 0;


return (
<div style={{ padding: '0 16px', overflow: 'hidden', maxHeight: '100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
{/* 5. CAMBIO CLAVE: Título en el header */}
<h1>Demostraciones</h1>
</div>
</header>
<div className="container" style={{ padding: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
{/* 6. CAMBIO CLAVE: Icono de Demostraciones */}
<DemostracionesIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
</div>
<h1 className="formtitle">Post Mortem</h1>
</div>
<hr className="divider" />
<div className="main-content-grid">
<div className="info-column" >
{/* 7. CAMBIO CLAVE: Usar 'demostracion' */}
<h1 className="event-title">{demostracion.titulo}</h1>

<div className="event-description" style={{maxWidth:'90%'}}> 
<ReactMarkdown 
children={demostracion.descripcion}
/>
</div>
<div className="details-subgrid" style={{ overflow: 'hidden', maxHeight: '70%' }}>
<div className="details-item" >
{/* 8. CAMBIO CLAVE: Mostrar cantidadPlazas */}
<label style={{ color: '#e65c5c' }}>Cantidad de Invitados</label>
<p>{cantidadInvitados} Plazas</p>

{/* Se elimina la sección de colección y botellas */}
</div>

{/* Se elimina la sección de Precio e Invitados detallados */}

<div className="details-item">
<div className="personas-list">
<label style={{ paddingBottom: '5px', color: '#e65c5c' }}>Staff</label>
<ul>
{staff.length > 0 ? (
staff.map((miembro, index) => (
<li style={{ fontSize: '17px', listStyle:'none',textDecoration:'none', margin:'0' }} key={index}>
{miembro.nombre}
</li>
))
) : (
<li style={{ fontSize: '14px' }}>No hay staff.</li>
)}
</ul>
</div>
</div>
<div className="details-item">
<div className="personas-list">
<label style={{ paddingBottom: '5px', color: '#e65c5c' }}>PRECIO POR INVITADO</label>
<p>${formatearPrecio(demostracion.precio)}</p>
</div>
</div>
</div>
</div>

<div className="post-mortem-column">
<div className="post-mortem-section">
<label>Post Mortem</label>
<div className="post-mortem-textarea-group">
<textarea
className="post-mortem-textarea"
rows="23"
maxLength={825}
placeholder="Escribí acá tus notas y reflexiones sobre la demostración..."
value={postMortemText}
onChange={(e) => setPostMortemText(e.target.value)}
disabled={isFinished}
/>
{!isFinished && (<div style={{
textAlign: 'right',
fontSize: '12px',
color: '#888',
marginRight: '5px',
fontFamily: 'Effra'
}}>
{postMortemText.length} / 825
</div>)}</div>

{!isFinished && (
<button className="postmortem-btn" onClick={handleSavePostMortem}>
Guardar
</button>
)}
</div>

</div>
</div>
</div>
</div>
);
};
export default DemostracionesDetails;